/**
 * Cursor Glow Effect
 * @description Tworzy efekt świecącego kursora, aktywowany tylko lokalnie.
 */
export function initCursorGlow(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return console.warn(`Brak sekcji: ${sectionSelector}`);

  const corner = section.querySelector('.corner');
  const inside = section.querySelector('.inside');
  const navbar = document.querySelector('.navbar');
  const cursorGlow = section.querySelector('#cursor-glow');
  if (!corner || !inside || !cursorGlow) return;

  let inputLocked = false;

  function interceptNavigationEvents(e) {
    if (!inputLocked) return;
    const blockedKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', ' ', 'Home', 'End'];
    if (e.type === 'keydown' && blockedKeys.includes(e.key)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
    if (e.type === 'wheel' || e.type === 'touchmove') {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }

  function lockInteraction() { inputLocked = true; }
  function unlockInteraction() { inputLocked = false; }

  function onCornerClick() {
    if (navbar) navbar.style.display = 'none';
    corner.style.display = 'none';
    inside.style.display = 'block';
    inside.classList.add('active');
    inside.style.clipPath = 'inset(0 0 0 0)';
    document.body.style.cursor = 'none';
    cursorGlow.style.display = 'block';
    lockInteraction();
  }

  function onInsideClick() {
    inside.style.opacity = '0';
    setTimeout(() => {
      inside.style.display = 'none';
      inside.classList.remove('active');
      inside.style.opacity = '';
      document.body.style.cursor = '';
      cursorGlow.style.display = 'none';
      if (navbar) navbar.style.display = 'flex';
      corner.style.display = 'block';
      unlockInteraction();
    }, 600);
  }

  function onMouseMove(e) {
    if (cursorGlow.style.display === 'block') {
      cursorGlow.style.left = `${e.clientX}px`;
      cursorGlow.style.top = `${e.clientY}px`;
    }
  }

  // Start / Stop w zależności od widoczności sekcji
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('wheel', interceptNavigationEvents, { passive: false, capture: true });
        document.addEventListener('touchmove', interceptNavigationEvents, { passive: false, capture: true });
        document.addEventListener('keydown', interceptNavigationEvents, true);
        corner.addEventListener('click', onCornerClick);
        inside.addEventListener('click', onInsideClick);
      } else {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('wheel', interceptNavigationEvents, true);
        document.removeEventListener('touchmove', interceptNavigationEvents, true);
        document.removeEventListener('keydown', interceptNavigationEvents, true);
        corner.removeEventListener('click', onCornerClick);
        inside.removeEventListener('click', onInsideClick);
        unlockInteraction();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(section);
}
